import { ECacheTime } from '@/lib/config/enum'
import { __cClubService } from '@/services/client/__c.club.service'
import { useQuery } from '@tanstack/react-query'
import { useUserQuery } from '../user/use-user'

export const useCoolClubMemberQuery = () => {
  const { data: user } = useUserQuery()
  return useQuery({
    queryKey: ['cool-club-member'],
    queryFn: async () => {
      try {
        const res = await __cClubService.getCoolClubMember(user?.id ?? '')
        return res
      } catch (error) {
        console.error('🧙 ~ error:', error)
        return null
      }
    },
    refetchOnMount: false,
    staleTime: ECacheTime.THREE_HOURS,
    notifyOnChangeProps: 'all',
    enabled: !!user?.id,
  })
}
